import React, { useState } from "react";

import {
  FaTag,
  FaShieldAlt,
  FaCar,
  FaClock,
} from "react-icons/fa";

import {
  FaCheckDouble
} from "react-icons/fa6";


const WhyChooseSection = () => {

  const [activeIndex, setActiveIndex] = useState(0);

  const accordionItems = [

    {
      icon: <FaTag />,
      title: "Affordable Sai Shirdi Cab Fares",
      description:
        "Sai Shirdi Cabs offers affordable and transparent taxi fares for comfortable pilgrimage journeys. Enjoy reliable cab services without worrying about hidden charges.",
      features: [
        "Transparent cab pricing",
        "No hidden charges",
        "One-way and round-trip options",
        "Multiple vehicle choices",
      ],
    },

    {
      icon: <FaShieldAlt />,
      title: "Safe & Comfortable Shirdi Travel",
      description:
        "Travel to Shirdi with experienced drivers and well-maintained vehicles. We focus on providing a safe, smooth and comfortable journey for families, senior citizens and devotees.",
      features: [
        "Experienced professional drivers",
        "Clean and well-maintained cars",
        "Safe and comfortable journeys",
        "24×7 customer assistance",
      ],
    },

    {
      icon: <FaCar />,
      title: "Comfortable Cars for Every Group",
      description:
        "Choose the right vehicle for your Shirdi trip, whether you are travelling alone, as a couple, with family or in a larger group.",
      features: [
        "Sedan cars for couples and small families",
        "Ertiga and MUV options",
        "Innova and Innova Crysta",
        "Spacious cars for group travel",
      ],
    },

    {
      icon: <FaClock />,
      title: "24×7 Sai Shirdi Cab Service",
      description:
        "Book your Sai Shirdi cab anytime for Sai Baba Darshan, pilgrimage trips, pickup and drop services or return journeys. Our team is available around the clock to assist with your travel plans.",
      features: [
        "24×7 cab booking",
        "Sai Baba Darshan trips",
        "One-way and return cabs",
        "Flexible pickup and drop",
      ],
    },

  ];


  const toggleAccordion = (index) => {

    setActiveIndex(
      activeIndex === index ? -1 : index
    );

  };


  return (

    <section className="why-section">

      <div className="why-container">

        <div className="why-grid">

          {/* Left Content */}

          <div className="why-content">

            <span className="why-heading">
              Why Choose Sai Shirdi Cabs
            </span>

            <h2>
              {/* Enjoy a safe, comfortable and hassle-free Shirdi
              pilgrimage with reliable cabs, experienced drivers
              and convenient pickup and drop services. */}
              Your Journey to Shirdi, Made Easy & Comfortable
            </h2>


            <div className="why-images">

              <div className="experience-box">

                <div>
                  15<span>+</span>
                </div>

                <p>
                  Years of Excellence
                </p>

              </div>


              <div className="image-one">

                <img
                  src="/images/why-choose-us4.jpg"
                  alt="Sai Shirdi Cab Service"
                />

              </div>


              <div className="image-two">

                <img
                  src="/images/why-choose-us5.png"
                  alt="Shirdi Cab Service"
                />

              </div>

            </div>

          </div>


          {/* Accordion */}

          <div className="accordion">

            {
              accordionItems.map((item, index) => (

                <div
                  className="accordion-item"
                  key={index}
                >
{/* 
                  <button
                    className="accordion-button bgj"
                    onClick={() => toggleAccordion(index)}
                  >

                    <span className="accordion-title">

                      <span className="icon-box">
                        {item.icon}
                      </span>

                      {item.title}

                    </span>


               

                  </button> */}
<button
  className={`accordion-button bgj ${
    activeIndex === index ? "accordion-active" : ""
  }`}
  onClick={() => toggleAccordion(index)}
>
  <span className="accordion-title">
    <span className="icon-box">
      {item.icon}
    </span>

    {item.title}
  </span>

  <span
    className={`accordion-arrow ${
      activeIndex === index ? "arrow-open" : ""
    }`}
  >
    <span></span>
  </span>
</button>


                  {
                    activeIndex === index &&

                    <div className="accordion-content">

                      <p>
                        {item.description}
                      </p>


                      <ul>

                        {
                          item.features.map((feature, i) => (

                            <li key={i}>

                              <FaCheckDouble />

                              {feature}

                            </li>

                          ))
                        }

                      </ul>

                    </div>
                  }

                </div>

              ))
            }

          </div>

        </div>

      </div>

    </section>

  );

};


export default WhyChooseSection;
